import { render, staticRenderFns } from "./SnippetMenu.vue?vue&type=template&id=0e06a7cc&scoped=true"
import script from "./SnippetMenu.vue?vue&type=script&lang=js"
export * from "./SnippetMenu.vue?vue&type=script&lang=js"
import style0 from "./SnippetMenu.vue?vue&type=style&index=0&id=0e06a7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e06a7cc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BasicButton: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/basic/BasicButton.vue').default})
